module.exports = __webpack_public_path__ + "static/media/proyeccion_card_detail.b639ca65.png";